<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader style="background-color: #145654"
            class="border-bottom d-flex justify-content-between align-items-center">
            <h4 class="card-title mb-0 text-white">
              <CIcon name="cil-window-restore" size="xl" /> {{ $t('mainuser.pageTitle') }}
            </h4>
            <button class="report-btn" @click="checkBeforeReport">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="12" y1="18" x2="12" y2="12" />
                <line x1="9" y1="15" x2="15" y2="15" />
              </svg>
              <span>{{ $t('mainuser.reportBtn') }}</span>
            </button>
          </CCardHeader>

          <CCardBody>
            <div class="custom-tabs">
              <div class="tabs-header">
                <button :class="['tab-item', { active: activeTab === 'report' }]" @click="activeTab = 'report'">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                  </svg>
                  <span style="font-size: 15px; font-weight: 500">{{ $t('mainuser.tabReports') }}</span>
                </button>
                <button :class="['tab-item', { active: activeTab === 'history' }]" @click="activeTab = 'history'">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                  </svg>
                  <span style="font-size: 15px; font-weight: 500">{{ $t('mainuser.tabHistory') }}</span>
                </button>
              </div>

              <div class="tabs-content">
                <div v-show="activeTab === 'report'" class="tab-panel">
                  <Ureportable ref="ureportTable" @show-detail="handleShowDetail" />
                </div>
                <div v-show="activeTab === 'history'" class="tab-panel">
                  <Uhistorytable ref="uhistoryTable" @show-detail="handleShowDetail" />
                </div>
              </div>
            </div>
          </CCardBody>
        </CCard>

        <UReportDetail v-if="selectedReport" :report="selectedReport" @close="closeDetail"
          @refresh="refreshTables"
          @submit-evaluation="handleEvaluationSubmit" />

      </CCol>
    </CRow>

    <SendReport v-model="sendReportModal" @ticket-created="handleTicketCreated" />
  </div>
</template>

<script>
import Uhistorytable from "../../components/user/Uhistorytable.vue";
import Ureportable from "../../components/user/Ureportable.vue";
import SendReport from "../../components/user/SendReport";
import UReportDetail from "./UReportDetail.vue";
import Swal from "sweetalert2";
import { getSocket } from "../../service/socketio.service";

export default {
  name: "Dashboard",
  components: {
    Ureportable,
    Uhistorytable,
    SendReport,
    UReportDetail, // Register ชื่อใหม่
  },
  data() {
    return {
      sendReportModal: false,
      activeTab: "report",
      selectedReport: null,
    };
  },
  mounted() {
    this.setupSocketListeners();
  },
  beforeDestroy() {
    const socket = getSocket();
    if (socket) {
      socket.off("user_ticket_updated");
    }
  },
  methods: {
    setupSocketListeners() {
      const socket = getSocket();
      if (socket) {
        socket.on("user_ticket_updated", (data) => {
          this.refreshTables();
          
          if (this.selectedReport && this.selectedReport._id === data._id) {
            if (data.status === 'cancelled') {
              this.selectedReport = null;
              Swal.fire({
                icon: 'info',
                title: this.$t('mainuser.ticketCancelledTitle'),
                text: this.$t('mainuser.ticketCancelledText'),
                confirmButtonColor: '#3085d6',
              });
            } else {
              this.selectedReport = { ...this.selectedReport, ...data };
            }
          }
        });
      }
    },
    refreshTables() {
      // เรียกใช้ฟังก์ชันเดียวกับที่ใช้ตอนสร้าง ticket
      this.handleTicketCreated();
    },
    handleTicketCreated() {
      if (this.$refs.ureportTable && typeof this.$refs.ureportTable.loadTickets === 'function') {
        this.$refs.ureportTable.loadTickets();
      }
      if (this.$refs.uhistoryTable && typeof this.$refs.uhistoryTable.loadHistory === 'function') {
        this.$refs.uhistoryTable.loadHistory();
      }
    },
    async checkBeforeReport() {
      const userStr = localStorage.getItem('user');
      const userId = userStr ? JSON.parse(userStr)._id : null;
      if (!userId) {
        this.sendReportModal = true;
        return;
      }
      try {
        const response = await fetch(`${process.env.VUE_APP_APP_URL}/ticket/user/${userId}/active`);
        if (response.ok) {
          const data = await response.json();
          if (data.success && Array.isArray(data.data)) {
            const unevaluatedTicket = data.data.find(t => t.status === 'done');
            if (unevaluatedTicket) {
              Swal.fire({
                icon: 'warning',
                title: this.$t('mainuser.evalBeforeNewTitle'),
                text: this.$t('mainuser.evalBeforeNewText'),
                confirmButtonColor: '#2ba9a5',
                confirmButtonText: this.$t('login.ok'),
                returnFocus: false
              }).then(() => {
                this.handleShowDetail(unevaluatedTicket);
              });
              return;
            }
          }
        }
      } catch (err) {
        console.error("Error checking unevaluated tickets", err);
      }
      this.sendReportModal = true;
    },
    handleShowDetail(item) {
      this.selectedReport = { ...item };

      // Scroll to detail
      this.$nextTick(() => {
        const detailCard = document.querySelector(".mt-4");
        if (detailCard) {
          detailCard.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },

    closeDetail() {
      this.selectedReport = null;
    },

    async handleEvaluationSubmit(data) {
      console.log("Evaluation received:", data);

      await Swal.fire({
        icon: "success",
        title: this.$t('mainuser.thanksEvalTitle'),
        html: `
        <div style="text-align:left; font-size:14px;">
          <p><strong>${this.$t('mainuser.evalTicketNo')}</strong> ${data.ticket_number}</p>
          <p><strong>${this.$t('mainuser.evalScore')}</strong> ${data.rating} ${this.$t('mainuser.evalStars')}</p>
          <p><strong>${this.$t('mainuser.evalComment')}</strong> ${data.comment || this.$t('mainuser.evalNoComment')}</p>
        </div>
      `,
        confirmButtonText: this.$t('login.ok'),
        confirmButtonColor: "#2ba9a5",
      });

      this.closeDetail();
    }
  }

};
</script>

<style scoped>
.report-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 32px;
  border: none;
  border-radius: 50px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4);
  transition: all 0.3s ease;
  animation: pulse-glow 2s ease-in-out infinite;
}

.report-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.5);
  animation: none;
}

.report-btn:active {
  transform: translateY(0);
}

.report-btn svg {
  width: 20px;
  height: 20px;
}

@keyframes pulse-glow {

  0%,
  100% {
    box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4);
    transform: scale(1);
  }

  50% {
    box-shadow: 0 6px 30px rgba(16, 185, 129, 0.8),
      0 0 50px rgba(16, 185, 129, 0.5);
    transform: scale(1.05);
  }
}

.custom-tabs {
  margin-top: 20px;
}

.tabs-header {
  display: flex;
  gap: 8px;
  border-bottom: 2px solid #e9ecef;
  margin-bottom: 20px;
}

.tab-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  background: transparent;
  color: #6c757d;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  position: relative;
  bottom: -2px;
}

.tab-item:hover {
  color: #495057;
  background: #f8f9fa;
}

.tab-item.active {
  color: #ffffff;
  font-weight: 600;
  border-bottom-color: #2ba9a5;
  background-color: #2ba9a5;
}
</style>